import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSafeguard } from './models';

export const Safeguard: FC<TSafeguard> = ({ Aligner, Grid, Img, Text, isMobile, styles, text }) => {
    const rowStyle = cn(styles.external, styles.gridRow);
    const gridStyles = {
        col: rowStyle,
    };

    return (
        <Grid
            className={cn(styles.external, styles.safeguard)}
            classNames={gridStyles}
            colAutoWidth
            justify="start"
        >
            <Img src="https://storage.yandexcloud.net/alfaleasing/components/alfa-shield_xxl.png" />
            <Aligner align="left" styler={{ marginLeft: 12, marginBottom: 0 }}>
                <Text
                    fontSize={isMobile ? 14 : 16}
                    fontWeight={4}
                    kind="caption"
                    lineHeight={isMobile ? 20 : 24}
                    tag="span"
                >
                    {text}
                </Text>
            </Aligner>
        </Grid>
    );
};
